import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TypingIndicator from './TypingIndicator'
import AgentAvatar from './AgentAvatar'
import RenderEmoji from './RenderEmoji'

const useStyles = makeStyles({
  agentMessageAvatar: {
    width: 30,
    gridColumnStart: 1,
    marginTop: 22,
    paddingLeft: 10
  },
  agentName: {
    fontFamily: 'Open Sans, sans serif',
    fontSize: '12px',
    color: '#7C7C7C',
    marginLeft: -10,
    marginBottom: -5
  }

})

function AgentMessageGroup (props) {
  const agent_name = props.agent_name
  const rows = props.messages
  const avatarUrl = props.avatarUrl
  const typing = props.typing
  const bot = props.bot ? props.bot : false

  const classes = useStyles()

  return (
    <div className='agent-message-group'>
      <div className={classes.agentMessageAvatar} style={typing ? { marginBottom: 10 } : { marginBottom: 0 }}>
        <AgentAvatar avatarUrl={avatarUrl} bot={bot} />
      </div>
      <div className='message-list'>
        <div className={classes.agentName}>{agent_name}</div>
        <>
          {rows.map(row => (
            <RenderEmoji
              rich='true'
              key={row.id}
              className='agent-message-text'
              text={row.attributes.body}
            />
          ))}
          {
            typing
              ? <TypingIndicator />
              : <></>
          }
        </>
      </div>
    </div>
  )
}

export default AgentMessageGroup
